export default {
  metadata: {
    version: '1.0.0',
    id: 'tag-1.0.0',
    name: 'SwadeshTag'
  },
  hierarchy: {
    container: ['start-icon', 'jds-text', 'end-icon']
  },
  base: {
    container: {
      hidden: false,
      display: 'flex',
      'flex-direction': '{t_0}',
      'justify-content': '{t_1}',
      'align-items': '{t_2}',
      'padding-top': '{t_3}',
      'padding-left': '{t_4}',
      'padding-right': '{t_5}',
      'padding-bottom': '{t_6}',
      gap: '{t_7}',
      'background-color': '{t_8}',
      'border-radius': '{t_24}',
      'border-width': '{t_9}',
      'border-color': '{t_25}',
      opacity: '{tag_base_container_opacity}',
      behavior: {
        active: {
          'border-color': '{t_10}'
        },
        focus: {
          'border-color': '{t_11}',
          'border-width': '{t_12}'
        },
        hover: {
          'border-color': '{t_26}',
          'background-color': '{t_36}'
        }
      }
    },
    'end-icon': {
      hidden: false,
      size: '{t_13}',
      color: '{t_27}',
      behavior: {
        hover: {
          color: '{t_14}'
        },
        active: {
          color: '{t_15}'
        },
        focus: {
          color: '{t_16}'
        }
      }
    },
    'start-icon': {
      hidden: false,
      size: '{t_13}',
      color: '{t_27}',
      behavior: {
        hover: {
          color: '{t_14}'
        },
        active: {
          color: '{t_15}'
        },
        focus: {
          color: '{t_16}'
        }
      }
    },
    'jds-text': {
      'font-family': '{text_132}',
      color: '{text_39}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      'max-lines': 1,
      hidden: false,
      maxLines: 1,
      behavior: {
        hover: {},
        active: {},
        focus: {}
      }
    }
  },
  variant: {
    kind: {
      tag: {
        container: {
          'background-color': '{t_37}'
        }
      }
    },
    size: {
      small: {
        container: {
          'padding-top': '{t_32}',
          'padding-left': '{t_33}',
          'padding-right': '{t_34}',
          'padding-bottom': '{t_35}'
        },
        'jds-text': {
          'font-family': '{text_147}',
          'font-size': '{text_146}',
          'line-height': '{text_148}',
          'letter-spacing': '{text_149}',
          'font-weight': '{text_150}'
        }
      }
    },
    active: {
      true: {
        container: {
          'background-color': '{t_17}',
          'border-width': '{t_29}',
          'border-color': '{t_28}',
          behavior: {
            hover: {
              'background-color': '{t_30}'
            },
            active: {
              'background-color': '{t_18}',
              'border-color': '{t_19}',
              'border-width': 1
            },
            focus: {
              'background-color': '{t_20}'
            }
          }
        },
        'end-icon': {
          color: '{t_21}',
          value: 'ic_close'
        },
        'start-icon': {
          color: '{t_21}',
          value: 'ic_close'
        },
        'jds-text': {}
      }
    },
    disabled: {
      true: {
        container: {
          disabled: true,
          'background-color': '{primaryGrey20}',
          'border-color': '{primaryGrey20}'
        },
        'start-icon': {
          color: 'primary_grey_60'
        },
        'end-icon': {
          color: 'primary_grey_60'
        },
        'jds-text': {
          color: '{text_22}'
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    data: {
      'start-icon': {
        value: {
          type: 'icon',
          name: 'startIcon'
        }
      },
      'end-icon': {
        value: {
          type: 'icon',
          name: 'endIcon'
        }
      },
      'jds-text': {
        value: {
          type: 'string',
          name: 'label'
        }
      }
    },
    config: {
      size: {
        values: ['medium', 'small']
      },
      kind: {
        values: ['chip', 'tag']
      },
      disabled: {
        values: [false, true]
      },
      active: {
        values: [false, true]
      }
    },
    events: {
      container: {
        onClick: 'onClick'
      }
    }
  }
};
